import {observer} from "mobx-react-lite";
import React, {useState} from "react";
import {useStore} from "../../helpers";
import { ChevronDownIcon } from "@heroicons/react/24/solid";
import Popover from "@material-ui/core/Popover";
import Typography from "@material-ui/core/Typography";
import Slider from "@material-ui/core/Slider";
import {makeStyles} from "@material-ui/core/styles";
import moment from "moment";
import {classNames} from "../../helpers/utils";

const useStyles = makeStyles({
    root: {
        width: 275,
    },
});

const valuetext = (value) => {
    return value
}

const dateFilters = [
    {
        value: 0,
        label: '1W',
    },
    {
        value: 10,
        label: '2W',
    },
    {
        value: 20,
        label: '1M',
    },
    {
        value: 30,
        label: '3M',
    },
    {
        value: 40,
        label: '6M',
    },
    {
        value: 50,
        label: '1Y',
    },
    {
        value: 60,
        label: 'Custom',
    },
];

export const DateFilter = observer((props: any) => {

    const rootStore = useStore();
    const {mediaStore} = rootStore;

    const [sliderValue, setSliderValue] = useState(0)
    const [custom, setCustom] = useState(false)
    const [customFromDate, setCustomFromDate] = useState(mediaStore.printMediaFilters.from_date)
    const [customToDate, setCustomToDate] = useState(mediaStore.printMediaFilters.to_date)
    const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

    const open  = () => {
        return Boolean(anchorEl)
    };

    const clickHandler = () => {
        if(customFromDate != null) mediaStore.printMediaFilters.from_date = customFromDate;
        if(customToDate != null) mediaStore.printMediaFilters.to_date = customToDate;
        setAnchorEl(null)
    }


    const popOverCalender = () => {
        
        return (
            <>
                <div className='flex flex-row flex-wrap cursor-pointer' onClick={(event) => {
                    // @ts-ignore
                    setAnchorEl(event.currentTarget)
                }}>
                    <div className='font-bold'>{label}</div>
                    <ChevronDownIcon
                        className={classNames(open ? 'text-gray-600' : 'text-gray-400', 'ml-2 h-5 w-5 group-hover:text-gray-500')}
                        aria-hidden="true"
                    />
                </div>

                <Popover
                    id='datefilter-popover'
                    open={open()}
                    anchorEl={anchorEl}
                    onClose={() => {
                        setAnchorEl(null)
                    }}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                >
                    <div
                        className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 overflow-hidden p-4"
                    style={{width: 320}}>
                        {CalenderSlider()}
                        {custom ?
                            <div className='flex flex-col flex-wrap mt-5'>
                                <div className='flex flex-col'>
                                    <label className='font-bold' htmlFor="From">From:</label>
                                    <input type='date' id='From' name='From'
                                           value={moment(customFromDate).format("YYYY-MM-DD")}
                                           className='border border-gray-300 p-2'
                                           onChange={(e) => {
                                                setCustomFromDate(moment(e.target.value))
                                           }}/>
                                </div>
                                <div className='flex flex-col mt-2'>
                                    <label className='font-bold' htmlFor="From">To:</label>
                                    <input type='date' id='From' name='From'
                                           value={moment(customToDate).format("YYYY-MM-DD")}
                                           className='border border-gray-300 p-2'
                                           onChange={(e) => {
                                               setCustomToDate(moment(e.target.value))
                                           }}/>
                                </div>
                            </div>
                            : null}

                        {
                            custom ? (
                                <div className='flex flex-row justify-end mt-2'>
                                    <button onClick={(event) => {
                                        setAnchorEl(null)
                                    }} className='bg-red-500 hover:bg-red-700 text-white font-bold p-2 rounded mr-2'>Cancel
                                    </button>
                                    <button className='bg-blue-500 hover:bg-blue-700 text-white font-bold p-2 rounded'
                                            onClick={clickHandler}>Apply
                                    </button>
                                </div>
                            ): null
                        }
                    </div>
                </Popover>

            </>
        )
    }

    const [label, setLabel] = useState('1 Week')

    const labelChangeHandler = (e, value) => {
        switch (value) {
            case 0:
                setCustom(false);
                mediaStore.setFilterDates(moment().subtract('days',7), moment());
                setLabel('1 Week')
                break;
            case 10:
                setCustom(false);
                mediaStore.setFilterDates(moment().subtract('weeks',2), moment());
                setLabel('2 Weeks')
                break;
            case 20:
                setCustom(false);
                mediaStore.setFilterDates(moment().subtract('month',1), moment());
                setLabel('1 Month')
                break;
            case 30:
                setCustom(false);
                mediaStore.setFilterDates(moment().subtract('months',3), moment());
                setLabel('3 Months')
                break;
            case 40:
                setCustom(false);
                mediaStore.setFilterDates(moment().subtract('months',6), moment());
                setLabel('6 Months')
                break;
            case 50:
                setCustom(false);
                mediaStore.setFilterDates(moment().subtract('year',1), moment());
                setLabel('1 Year')
                break;
            case 60:
                setCustom(true);
                setLabel('Custom')
                break;
            default:
                setCustom(false);
                mediaStore.setFilterDates(moment().subtract('days',7), moment());
        }
        setSliderValue(value);
    }

    const CalenderSlider = () => {
        const classes = useStyles();

        return (
            <>
                <div className={classes.root}>
                    <Typography id="discrete-slider" gutterBottom>
                        Select date range
                    </Typography>
                    <Slider
                        min={0}
                        max={60}
                        value={sliderValue}
                        marks={dateFilters}
                        track={false}
                        step={null}
                        // @ts-ignore
                        getAriaValueText={valuetext}
                        onChangeCommitted={labelChangeHandler}
                    />
                </div>
            </>
        )
    }

    return (
        <>
            <div className='flex flex-row justify-between items-center lg:flex-col '>
                <div className='px-2'>Date:</div>
                <div className='rounded-lg bg-white flex flex-row p-2 items-center justify-between lg:w-80'>
                    <div>{popOverCalender()}</div>
                    <div className=''>{mediaStore.printMediaFilters.from_date.format('YYYY-MM-DD')} to {mediaStore.printMediaFilters.to_date.format('YYYY-MM-DD')}</div>
                </div>
            </div>

        </>
    );

});